<div class="d-flex justify-content-center" *ngIf="spinerDisplay == true">
    <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>
<div class="row" *ngIf="spinerDisplay == false">
    <div class="col-xl-9 col-lg-8 col-md-8">
        <p class="table-header-title">Click a Column header to order by the Column</p>
    </div>
    <!-- <div class=""> -->
    <div class="col-xl-2 col-lg-2 col-md-2 mt-4">
        <div class="example-header filer-section">
            <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
                <input matInput (keyup)="applyFilter($event.target.value)" [(ngModel)]="searchKey" placeholder="Filter"
                    #input />
            </mat-form-field>
        </div>
    </div>
    <!-- </div> -->
    <div class="col-xl-1 col-lg-2 col-md-2 text-end export-import-section">
        <!-- <app-matrix-import></app-matrix-import>
        <app-matrix-export></app-matrix-export> -->
    </div>
</div>

<div class="row" *ngIf="spinerDisplay == false">
    <div class="col-md-12 mt-4 mb-4">
        <div class="table_responsive">
            <table mat-table class="mat-elevation-z8 mat-table-wrapper" [dataSource]="dataSource" matSort>
                <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef>
                        <mat-checkbox class="checkbox-wrap" (change)="$event ? masterToggle() : null"
                            [checked]="selection.hasValue() && isAllSelected()"
                            [indeterminate]="selection.hasValue() && !isAllSelected()">
                        </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <mat-checkbox class="checkbox-wrap" (click)="$event.stopPropagation()"
                            (change)="OnChange($event, row)" [checked]="selection.isSelected(row)">
                        </mat-checkbox>
                    </td>
                </ng-container>

                <ng-container matColumnDef="userMatrixRowId" hidden="hidden">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.userMatrixRowId }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="userMatrixId" hidden="hidden">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.userMatrixId }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="userMatrixRow" hidden="hidden">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.userMatrixRow }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="jointId">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 10%">Joint ID</th>
                    <td mat-cell *matCellDef="let element">
                        <div class="d-flex">
                            <div class="ellipsis-cell" matTooltip="{{ element.jointId }}"
                                [matTooltipDisabled]="!checkTextOverFlow(element.userMatrixRowId)"
                                id="{{ element.userMatrixRowId }}">
                                <!-- <div class="table-p-tag truncate-text">{{element.jointId}} </div> -->
                                {{ element.jointId }}
                            </div>
                            <div class="ms-3">
                                <app-matrix-row-modify [userMatrixRowId]="element.userMatrixRowId"
                                    [userMatrixJointId]="element.jointId"
                                    (refreshMatrixrow)="userMetrixRefresh($event)"></app-matrix-row-modify>
                            </div>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="calculationType">
                    <th *matHeaderCellDef mat-sort-header mat-header-cell style="width: 9%">Calculation Type</th>
                    <td *matCellDef="let element" mat-cell>
                        {{ element.calculationType }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="calculationDate">
                    <th *matHeaderCellDef mat-sort-header mat-header-cell style="width: 10%">Calculation Date</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.calculationDate | date: 'short' }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="pressureClassName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Class</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.pressureClassName }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="pipeSize">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 5%">Size</th>
                    <td mat-cell *matCellDef="let element">{{ element.pipeSize }}</td>
                </ng-container>
                <ng-container matColumnDef="gasketName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Gasket</th>
                    <td mat-cell *matCellDef="let element">{{ element.gasketName }}</td>
                </ng-container>
                <ng-container matColumnDef="residualBoltLoad">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 8%">Residual Bolt Load</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.residualBoltLoad }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="residualBoltStress">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 8%">Residual Bolt Stress</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.residualBoltStress }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="tighteningMethod">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 8%">Tightening Method</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.tighteningMethod }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="toolName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 10%">Tool Name</th>
                    <td mat-cell *matCellDef="let element">{{ element.toolName }}</td>
                </ng-container>
                <ng-container matColumnDef="toolPressure">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 8%">Tool Pressure</th>
                    <td mat-cell *matCellDef="let element">{{ element.toolPressure }}</td>
                </ng-container>

                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 8%">Action</th>
                    <td mat-cell *matCellDef="let element">
                        <div class="d-flex flex-nowrap">
                            <app-matrix-row-duplicate class="px-0" [userMatrixRow]="element.userMatrixRow"
                                (refreshMatrixrow)="userMetrixRefresh($event)"></app-matrix-row-duplicate>
                            <app-matrix-row-remove class="px-0" [userMatrixRow]="element"
                                [userMatrixRows]="selectedUserMatrixRowIDItems"
                                (refreshMatrixrow)="userMetrixRefresh($event)"></app-matrix-row-remove>
                            <app-matrix-row-view class="px-0"
                                [userMatrixRow]="element.userMatrixRow"></app-matrix-row-view>
                        </div>
                    </td>
                </ng-container>

                <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
                <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell error-message" colspan="4">
                        <div *ngIf="dataSource.data.length <= 0; else elseBlock">No data available.</div>
                        <ng-template #elseBlock> No data matching "{{ searchKey }}" </ng-template>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</div>